import PropTypes from "prop-types";

/**
 * DifferentiationSelectors - Renders school, grade, and subject selection dropdowns
 */
const DifferentiationSelectors = ({
    allLocationDtos,
    gradesForSelect,
    gradingProfilesCurrentSem,
    selectedGrade,
    selectedSchoolLocationKey,
    selectedTemplate,
    setSelectedGrade,
    setSelectedSchoolLocationKey,
    setSelectedTemplate,
    sharedLocationKeys,
    showGradeSelect,
    showSchoolSelect,
    showSubjectSelect,
    subjectOptions,
    dispatch
}) => {
    const handleSubjectChange = (e) => {
        const value = e.target.value;
        if (value === "") return;
        const templateId = Number(value);
        const subject = subjectOptions.find((s) => s.templateId === templateId) || null;
        setSelectedTemplate(subject);
    };

    return (
        <div style={{ display: "flex", gap: "0px 24px", flexWrap: "wrap" }}>
            {showSchoolSelect && (
                <section className="epr-selector-ratings">
                    <h5>Select a School:</h5>
                    <select
                        className="rating-select-dropdown"
                        value={Number(selectedSchoolLocationKey) || ""}
                        onChange={(e) => {
                            setSelectedSchoolLocationKey(Number(e.target.value));
                            setSelectedGrade(null);
                            setSelectedTemplate(null);
                        }}
                    >
                        <option value="" disabled>
                            Select School
                        </option>
                        {sharedLocationKeys.map((k) => (
                            <option key={k} value={k}>
                                {allLocationDtos.find((loc) => Number(loc.key) === Number(k))?.name}
                            </option>
                        ))}
                    </select>
                </section>
            )}

            {showGradeSelect && (
                <section className="epr-selector-ratings">
                    <h5>Select a Grade:</h5>
                    <select
                        className="rating-select-dropdown"
                        value={selectedGrade || ""}
                        onChange={(e) => {
                            const gradeName = e.target.value;
                            setSelectedGrade(gradeName);
                            const selectedGradingProfile =
                                gradingProfilesCurrentSem?.find((p) => p.gradeName === gradeName) || null;
                            dispatch({ type: "SET_SELECTED_EPR", payload: selectedGradingProfile });
                            setSelectedTemplate(null);
                        }}
                    >
                        <option value="" disabled>
                            Select Grade
                        </option>
                        {gradesForSelect.map((gradeName) => (
                            <option key={gradeName} value={gradeName}>
                                {gradeName === "K" ? "Kindergarten" : `${gradeName} Grade`}
                            </option>
                        ))}
                    </select>
                </section>
            )}

            {showSubjectSelect && (
                <section className="epr-selector-ratings">
                    <h5>Select a Subject:</h5>
                    <select
                        className="rating-select-dropdown"
                        onChange={handleSubjectChange}
                        value={selectedTemplate ? String(selectedTemplate.templateId) : ""}
                    >
                        <option value="" disabled>
                            Select a Subject
                        </option>
                        {subjectOptions.map((s) => (
                            <option key={s.templateId} value={s.templateId}>
                                {s.subjectName}
                            </option>
                        ))}
                    </select>
                </section>
            )}
        </div>
    );
};

DifferentiationSelectors.propTypes = {
    allLocationDtos: PropTypes.array,
    gradesForSelect: PropTypes.array.isRequired,
    gradingProfilesCurrentSem: PropTypes.array.isRequired,
    selectedGrade: PropTypes.string,
    selectedSchoolLocationKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedTemplate: PropTypes.object,
    setSelectedGrade: PropTypes.func.isRequired,
    setSelectedSchoolLocationKey: PropTypes.func.isRequired,
    setSelectedTemplate: PropTypes.func.isRequired,
    sharedLocationKeys: PropTypes.array.isRequired,
    showGradeSelect: PropTypes.bool.isRequired,
    showSchoolSelect: PropTypes.bool.isRequired,
    showSubjectSelect: PropTypes.bool.isRequired,
    subjectOptions: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired
};

DifferentiationSelectors.defaultProps = {
    allLocationDtos: [],
    selectedGrade: null,
    selectedSchoolLocationKey: null,
    selectedTemplate: null
};

export default DifferentiationSelectors;
